<template>
  <kst-form v-if="purchaseId" no-bezel class="pb-5">
    <template #top-right>
      <kst-button action-mode full-label
        class="is-primary"
        :module="Model.Module"
        :moduleType="Model.ModuleType.New"
        :urlParams="urlParams"
      />
    </template>
  </kst-form>
</template>

<script>
import Model from "../ReceiveModel.js";

export default {
  props: {
    purchaseId: Number
  },
  data: () => ({
    Model: Model
  }),
  computed: {
    urlParams() {
      return this.$kst.Route.getParams({
        [this.$kst.Enum.Param.PurchaseID]: this.purchaseId
      });
    }
  },
}
</script>